import { render, staticRenderFns } from "./moMessage.vue?vue&type=template&id=389ab1b2&scoped=true&"
import script from "./moMessage.vue?vue&type=script&lang=js&"
export * from "./moMessage.vue?vue&type=script&lang=js&"
import style0 from "./moMessage.vue?vue&type=style&index=0&id=389ab1b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ab1b2",
  null
  
)

export default component.exports